module.exports = __webpack_public_path__ + "static/media/kitapaktivasyonu_ADIM2.3ee40d3a.jpg";